<template>
  <div class="kuangji-page">
    <!-- 顶部导航栏 -->
    <div class="header">
      <button class="back-btn" @click="goback">
      </button>
      <h1 class="title">TND矿机</h1>
      <button class="more-btn"></button>
    </div>

    <!-- 主体内容 -->
    <div class="main">
      <!-- 矿机图片区域 → 添加点击跳转 -->
      <div 
        class="machine-image-wrapper"
        @click="goToRemainCount"
        style="cursor: pointer;"
      >
        <img src="@/assets/images/kj2.png" alt="矿机" class="machine-image">
      </div>

      <!-- 算力显示 -->
      <div class="stats-header">
        <h2 class="power-title">算力 <span class="power-value">{{ displayNumber }}</span></h2>
        <p class="rate-info">运力7.57399 &nbsp; | &nbsp; {{ displayRate }}/秒</p>
      </div>

      <!-- 矿机状态卡片 -->
      <div class="status-cards">
        <div class="status-card">
          <div class="card-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b7cf5" stroke-width="2">
              <rect x="2" y="3" width="20" height="14" rx="2" />
              <line x1="8" y1="21" x2="16" y2="21" />
              <line x1="12" y1="17" x2="12" y2="21" />
            </svg>
          </div>
          <div class="card-title">矿机总数</div>
          <div class="card-detail">
            <div class="detail-row">
              <span>运行中</span>
              <span>{{ runningMachines }}</span>
            </div>
            <div class="detail-row">
              <span>总矿机</span>
              <span>{{ totalMachines }}</span>
            </div>
            <div class="detail-row">
              <span>TND矿机</span>
              <span>{{ totalMachines }}</span>
            </div>
          </div>
        </div>

        <div class="status-card">
          <div class="card-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b7cf5" stroke-width="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
          </div>
          <div class="card-title">失效矿机</div>
          <div class="card-detail">
            <div class="detail-row">
              <span>已失效</span>
              <span>{{ expiredMachines }}</span>
            </div>
            <div class="detail-row">
              <span>失效总数</span>
              <span>{{ expiredMachines }}</span>
            </div>
            <div class="detail-row">
              <span>TND矿机</span>
              <span>{{ expiredMachines }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 启动矿机按钮 -->
      <button class="start-btn" @click="startMachine" :disabled="isStarted">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3">
          <polyline points="5 12 19 12 12 5" />
          <polyline points="12 19 19 12 12 5" />
        </svg>
        {{ isStarted ? '已启动挖矿' : '启动矿机' }}
      </button>
    </div>
  </div>
</template>

<script>
import { ethers } from 'ethers';
import { contractAddress, contractABI } from '@/js/contract.js';

export default {
  name: 'kuangji',
  data() {
    return {
      myMachines: [],
      totalMachines: 0,      // 所有矿机总数
      runningMachines: 0,    // 运行中（有效）矿机
      expiredMachines: 0,    // 失效矿机（自动统计）
      displayNumber: 0,
      displayRate: 0,
      isStarted: false,
      counterInterval: null
    };
  },
  mounted() {
    this.fetchData();
    this.checkMachineStatus();
  },
  beforeDestroy() {
    if (this.counterInterval) clearInterval(this.counterInterval);
  },
  methods: {
    // 返回
    goback() {
      this.$router.go(-1);
    },
    
    // 跳转到剩余次数页面
    goToRemainCount() {
      this.$router.push('/remain-Count');
    },
    
    // 连接钱包
    async connectWallet() {
      if (window.ethereum) {
        try {
          await window.ethereum.request({ method: "eth_requestAccounts" });
          return new ethers.providers.Web3Provider(window.ethereum);
        } catch (error) {
          console.error("用户拒绝了账户访问请求", error);
        }
      } else {
        console.error("未检测到Ethereum提供商。请安装MetaMask。");
      }
    },

    // 获取我的矿机列表 ✅ 修复：完全匹配合约返回
    async fetchMyMachines() {
      const provider = await this.connectWallet();
      if (!provider) return;
      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddress, contractABI, signer);

      try {
        // 合约返回：types, counts, remainDays, prices
        const [types, counts, remainDays, prices] = await contract.getMyMachineInvestments();
        
        let list = [];
        let total = 0;
        let running = 0;
        let expired = 0;

        for (let i = 0; i < types.length; i++) {
          const count = counts[i].toNumber();
          const days = remainDays[i].toNumber();
          
          list.push({
            type: types[i].toNumber(),
            count: count,
            remainingDays: days,
            price: prices[i].toString()
          });

          // ✅ 按真实台数统计
          total += count;
          if (days > 0) {
            running += count;
          } else {
            expired += count;
          }
        }

        this.myMachines = list;
        this.totalMachines = total;
        this.runningMachines = running;
        this.expiredMachines = expired;
        
      } catch (err) {
        // 未注册用户不报错
        console.log("暂无矿机");
      }
    },

    // 统一获取数据
    async fetchData() {
      await this.fetchMyMachines();
    },

    // 算力动画（保留随机数，不修改）
    startCounter() {
      this.counterInterval = setInterval(() => {
        this.displayNumber = (parseFloat(this.displayNumber) + Math.random()).toFixed(5);
        this.displayRate = (Math.random() * 0.00001).toFixed(10);
      }, 1000);
    },
    startMachine() {
      if (!this.isStarted) {
        this.isStarted = true;
        localStorage.setItem('machineStarted', 'true');
        this.startCounter();
      }
    },
    checkMachineStatus() {
      const machineStarted = localStorage.getItem('machineStarted');
      if (machineStarted === 'true') {
        this.isStarted = true;
        this.startCounter();
      }
    }
  }
};
</script>

<style scoped>
/* 全局布局 */
.kuangji-page {
  min-height: 100vh;
  background: url(@/assets/images/bgimg.png) center center no-repeat fixed;
  background-size: cover;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  height: 850px;
}

/* 顶部导航 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: transparent;
}
.back-btn, .more-btn {
  background: none;
  border: none;
  color: #333;
  cursor: pointer;
  padding: 4px;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

/* 主体内容 */
.main {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 矿机图片区域 */
.machine-image-wrapper {
  width: 220px;
  height: 220px;
  margin: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%);
  border-radius: 50%;
}
.machine-image {
  width: 260px;
  height: auto;
  filter: drop-shadow(0 0 12px rgba(255,255,255,0.8)) drop-shadow(0 0 24px rgba(255,255,255,0.5));
}

/* 算力显示 */
.stats-header {
  text-align: center;
  margin-bottom: 30px;
}
.power-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 8px 0;
}
.power-value {
  color: #3b7cf5;
}
.rate-info {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* 状态卡片 */
.status-cards {
  display: flex;
  gap: 16px;
  width: 100%;
  margin-bottom: 30px;
}
.status-card {
  flex: 1;
  background: rgba(255,255,255,0.8);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}
.card-icon {
  margin-bottom: 12px;
}
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 16px 0;
  text-align: center;
}
.card-detail {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.detail-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #666;
}
.detail-row span:last-child {
  font-weight: 500;
  color: #333;
}

/* 启动按钮 */
.start-btn {
  width: 100%;
  background: linear-gradient(90deg, #3b7cf5, #66aaff);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(59, 124, 245, 0.3);
}
.start-btn:disabled {
  background: #999;
  cursor: not-allowed;
}
.start-btn:hover:not(:disabled) {
  opacity: 0.95;
}
</style>